let currentAudio = null;

/**
 * Plays a sound effect from the public/sounds folder.
 * @param {string} soundFile - The name of the sound file (e.g., 'navigate.mp3').
 * @param {boolean} soundEnabled - The global state from AccessibilityContext.
 */
export const playSound = (soundFile, soundEnabled) => {
  if (!soundEnabled) {
    return; // Do nothing if sounds are disabled
  }

  try {
    // Stop any previously playing sound to prevent overlap
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
    }
    
    const audio = new Audio(`/sounds/${soundFile}`);
    audio.play().catch(error => {
      // Autoplay was prevented, which is a common browser policy.
      // This is okay, we can ignore this specific error silently.
      if (error.name !== 'NotAllowedError') {
        console.error("Audio playback error:", error);
      }
    });
    currentAudio = audio;
  } catch (error) {
    console.error("Error playing sound:", error);
  }
};